module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/views/report-main.component.html
// module id = ../../../../../src/app/core-modules/report/views/report-main.component.html
// module chunks = main